var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"wechat-title",rawName:"v-wechat-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('Head'),_c('SideBar'),_c('div',{staticClass:"cs-container"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }